import React from 'react';
import SystemBatchRun from "../containers/SystemBatchRun/SystemBatchRun";

export const SystemBatchRunPage: React.FC = () => <SystemBatchRun />;

